import React from 'react';
import  '../../../css/AddTripForm/Element.css';
import FormField from '../FormField';

const AttractionElement = ({ data, handleChange }) => {
  const handleIsWithLimitedPlaces = async (field, value) => {
    if (value === false)
    {
      handleChange('capacity', null);
    }
    handleChange(field, value);
  }
  const isLinked = data.variants.length > 1;

  return (
    <div className="attractionContainer">
      <FormField
        label="Nazwa"
        name="name"
        type="text"
        value={data.name || ''}
        onChange={handleChange}
        placeholder="Podaj nazwę atrakcji"
        required={true}
      />

      <FormField
        label="Opis"
        name="description"
        type="richtext"
        value={data.description || ''}
        onChange={handleChange}
        placeholder="Aby użyć link wpisz dowolny tekst (np. Klik) a następnie go zaznacz i wybierz ostatni symbol z paska narzędzi. To pozwoli Ci wpisać link."
      />

      <FormField
        label="Czas rozpoczęcia"
        name="startDate"
        type="datetime-local"
        value={data.startDate || ''}
        onChange={(field, value) => handleChange(field, value)}
        required={true}
      />

<FormField
        label="Czy z limitem miejsc?"
        name="isWithLimitedPlaces"
        type="toggle"
        value={data.isWithLimitedPlaces}
        onChange={(field, value) => handleIsWithLimitedPlaces(field, value)}
      />
    { data.isWithLimitedPlaces && (<FormField
        label={"Limit miejsc"}
        name="capacity"
        type="number"
        min="1"
        step="1"
        value={data.capacity?.toString() || ""}
        onChange={(field, value) => handleChange(field, value)}
        required
      />)
    }

      <FormField
          label="Link"
          name="link"
          type="text"
          value={data.link || ''}
          onChange={handleChange}
          placeholder="Podaj link do szczegółów atrakcji"
        />

      <FormField
        label="Ustalona cena (brutto) na osobę"
        name="pricePerPerson"
        type="number"
        value={data.pricePerPerson?.toString() || ''}
        onChange={handleChange}
        placeholder="Podaj cenę"
        step="0.01"
        min="0"
        unit="zł"
        info="Pamiętaj o uwzględnieniu buforu (10% oryginalnego kosztu, nie mniej niż 6 zł) i ewentualnym pokryciu kosztów osoby koordynatorskiej"
      />

      <FormField
        label="Kwota z faktury"
        name="invoiceAmount"
        type="number"
        value={data.invoiceAmount?.toString() || ''}
        onChange={handleChange}
        placeholder="Podaj kwotę z faktury"
        step="0.01"
        min="0"
        unit="zł"
        info="Prognozowana kwota z faktury. Widoczna tylko w widoku Zestawienia. Nie jest wyświetlana na formularzu zapisów."
      />

       <FormField
        label="Komentarz (do rozliczeń)"
        name="internalComment"
        type="textarea"
        value={data.internalComment || ''}
        onChange={handleChange}
        placeholder="Komentarz dla osoby koordynatorskiej"
        info="Widoczny tylko w widoku Zestawienia. Nie jest wyświetlany na formularzu zapisów."
      />
    </div>
  );
};

export default AttractionElement;
